// extracted by mini-css-extract-plugin
module.exports = {"icon":"_9400a595a7--icon--Qmi2W"};